<script setup lang="ts">
import type { Instance } from '@/models/api-generated'

const props = defineProps<{
	instances: Instance[]
}>()
</script>

<template>
	<template v-if="props.instances.length > 5">
		<span class="badge text-bg-secondary" v-one-tooltip="props.instances.map((x) => x.name).join('\n')">
			<i class="bi bi-building me-1"></i>
			{{ props.instances.length }}
		</span>
	</template>
	<template v-else v-for="i in props.instances" :key="i.id">
		<div>{{ i.name }}</div>
	</template>
</template>

<style lang="sass" scoped>
span
  cursor: default
</style>
